/**
 * Infinite scroll for collection pages with Variable Products.
 * Reads VP's firstAmount to match, then lazy loads more as user scrolls.
 */
(function () {
  var VP_FIRST =
    typeof VariableProductsParams !== 'undefined' &&
    VariableProductsParams.lazyload &&
    VariableProductsParams.lazyload.firstAmount;
  var INITIAL_COUNT = VP_FIRST || 36;
  var BATCH_SIZE = 12;
  var POLL_INTERVAL = 100;
  var POLL_TIMEOUT = 10000;
  var OBSERVER_MARGIN = '300px';

  function init() {
    var startTime = Date.now();
    var pollTimer = setInterval(function () {
      if (Date.now() - startTime > POLL_TIMEOUT) {
        clearInterval(pollTimer);
        return;
      }
      if (
        typeof variableProductsInited !== 'undefined' &&
        variableProductsInited === true &&
        !document.querySelector('[data-behavior="variable-products"]') &&
        document.querySelectorAll('.variable-products').length > 0
      ) {
        clearInterval(pollTimer);
        setup();
      }
    }, POLL_INTERVAL);
  }

  function getItemsPerRow(items) {
    if (items.length < 2) return 1;
    var firstTop = items[0].getBoundingClientRect().top;
    for (var i = 1; i < items.length; i++) {
      if (items[i].getBoundingClientRect().top !== firstTop) return i;
    }
    return items.length;
  }

  function setup() {
    var allItems = document.querySelectorAll(
      '#CollectionAjaxContent .variable-products'
    );
    var totalItems = allItems.length;

    if (totalItems <= INITIAL_COUNT) return;

    // Only hide items beyond the initial count (avoids flickering
    // items that Variable Products already made visible)
    for (var i = INITIAL_COUNT; i < totalItems; i++) {
      allItems[i].style.display = 'none';
    }

    var visibleCount = INITIAL_COUNT;

    // Hide Shopify pagination
    var pagination = document.querySelector('#CollectionAjaxContent .pagination');
    if (pagination) pagination.style.display = 'none';

    // Create sentinel element
    var sentinel = document.createElement('div');
    sentinel.style.height = '1px';
    sentinel.style.width = '100%';
    sentinel.setAttribute('aria-hidden', 'true');

    function placeSentinel() {
      var currentItems = document.querySelectorAll(
        '#CollectionAjaxContent .variable-products'
      );
      var visibleItems = [];
      for (var i = 0; i < currentItems.length; i++) {
        if (currentItems[i].style.display !== 'none') {
          visibleItems.push(currentItems[i]);
        }
      }
      if (visibleItems.length === 0) return;

      var perRow = getItemsPerRow(visibleItems);
      // Place sentinel after the item one row before the last visible row
      var targetIndex = visibleItems.length - perRow - 1;
      if (targetIndex < 0) targetIndex = visibleItems.length - 1;

      var targetItem = visibleItems[targetIndex];
      if (targetItem && targetItem.parentNode) {
        targetItem.parentNode.insertBefore(sentinel, targetItem.nextSibling);
      }
    }

    function showNextBatch() {
      var allItems = document.querySelectorAll(
        '#CollectionAjaxContent .variable-products'
      );
      var totalItems = allItems.length;
      var end = Math.min(visibleCount + BATCH_SIZE, totalItems);

      for (var i = visibleCount; i < end; i++) {
        allItems[i].style.display = '';
      }
      visibleCount = end;

      if (visibleCount >= totalItems) {
        observer.disconnect();
        if (sentinel.parentNode) sentinel.parentNode.removeChild(sentinel);
        return;
      }

      placeSentinel();
    }

    var observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            showNextBatch();
          }
        }
      },
      { rootMargin: OBSERVER_MARGIN }
    );

    placeSentinel();
    observer.observe(sentinel);

    // Watch for variable-products.js re-initialization (e.g. after filter changes)
    var container = document.querySelector('#CollectionAjaxContent');
    if (container) {
      var mutationObserver = new MutationObserver(function () {
        var hasVariableItems =
          container.querySelectorAll('.variable-products').length > 0;
        var noHiddenMain = !container.querySelector(
          '[data-behavior="variable-products"]'
        );

        if (hasVariableItems && noHiddenMain) {
          // Disconnect to avoid loops, then re-setup
          observer.disconnect();
          mutationObserver.disconnect();
          if (sentinel.parentNode) sentinel.parentNode.removeChild(sentinel);

          // Small delay to let variable-products.js finish all DOM work
          setTimeout(function () {
            setup();
          }, 200);
        }
      });
      mutationObserver.observe(container, { childList: true, subtree: true });
    }
  }

  // Start when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
